import React, { useEffect } from "react";
import { Link } from "react-router-dom";

const ThankYou = () => {
  useEffect(() => {
    // Fire Google Analytics conversion event
    if (window.gtag) {
      window.gtag('event', 'conversion', {
        'send_to': 'AW-17124072772/cpbmCL3R-c4aEMS6suU_'
      });
    }
  }, []);

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center px-4">
      <div className="max-w-2xl w-full bg-white rounded-lg shadow-lg p-8 text-center">
        <div className="w-24 h-24 mx-auto bg-green-100 rounded-full flex items-center justify-center mb-6">
          <svg className="w-12 h-12 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
          </svg>
        </div>
        
        <h1 className="text-4xl font-bold text-blue mb-4 hellix-font">Thank You!</h1>
        
        <p className="text-xl text-gray-700 mb-6 hellix-font">
          Your enquiry has been successfully submitted. We appreciate your interest and will get back to you shortly.
        </p>
        
        <div className="bg-blue-50 rounded-lg p-6 mb-8">
          <h2 className="text-2xl font-semibold text-blue mb-3 hellix-font">What happens next?</h2>
          <div className="text-left space-y-3">
            <div className="flex items-start">
              <div className="w-6 h-6 bg-blue text-white rounded-full flex items-center justify-center text-sm font-bold mr-3 mt-1">1</div>
              <p className="text-gray-700 hellix-font">Our migration experts will review your enquiry within 24 hours</p>
            </div>
            <div className="flex items-start">
              <div className="w-6 h-6 bg-blue text-white rounded-full flex items-center justify-center text-sm font-bold mr-3 mt-1">2</div>
              <p className="text-gray-700 hellix-font">We'll contact you to discuss your migration goals and options</p>
            </div>
            <div className="flex items-start">
              <div className="w-6 h-6 bg-blue text-white rounded-full flex items-center justify-center text-sm font-bold mr-3 mt-1">3</div>
              <p className="text-gray-700 hellix-font">Receive personalized guidance for your Australian visa journey</p>
            </div>
          </div>
        </div>
        
        <div className="space-y-4">
          <Link
            to="/"
            className="inline-block bg-background text-white text-lg font-medium px-8 py-3 rounded-lg hover:bg-blue-700 transition-colors hellix-font"
          >
            Return to Home
          </Link>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center text-sm text-gray-600">
            <div className="flex items-center">
              <svg className="w-4 h-4 mr-2" fill="currentColor" viewBox="0 0 20 20">
                <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z"></path>
                <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z"></path>
              </svg>
              <span>connect@immigetglobal.com</span>
            </div>
            <div className="flex items-center">
              <svg className="w-4 h-4 mr-2" fill="currentColor" viewBox="0 0 20 20">
                <path d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z"></path>
              </svg>
              <span>+61 03 7065 8787</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ThankYou;